import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import DocReadButtons from './helper/DocReadButtons';
import { Group, Grid, ScrollArea} from '@mantine/core';
import { FileText, FileCheck  } from 'tabler-icons-react';
import PdfLabel from './helper/PdfLabel';


/**
 * Generates the document reading interface .
 *
 * @param {any} props.divheight - reguliert das einblenden oder ausblenden der Scrollbar im Szene Container
 * @return {JSX.Element} the JSX element representing the document reading interface
 */
const DocRead = (props:any) =>{
  const drnId = useSelector((state: any) => state.user.meetinginfo.drnId)
  const initdocs = useSelector((state: any) => state.user.meetingdocs)
  const [readinorigress, setreadinorigress] = useState({view: false, resourceId: "" });
  const [showscrollbar, setshowscrollbar] = useState(false);

  

useEffect(() => {
  if (props.divheight > 420 ) {
    setshowscrollbar(true)
  }
}, [props]);
  

  
  let initdocsdata
  initdocsdata = initdocs.filter((obj: { isToBeRead: boolean; }) => {
    return obj.isToBeRead === true
  });

  const rows = (initdocsdata || []).map((item:any, index:any) => {
   return (
    <div key={index}>
   <Grid>
   <Grid.Col span={2}> 
    {!item.isReadOut &&  
    <FileText size={48} strokeWidth={1} />
    }
    {item.isReadOut &&  
    <FileCheck size={48} strokeWidth={1} color="green" />
    }
  
</Grid.Col>
   <Grid.Col span={7}> 
   <PdfLabel isPDFA1b={item.isPDFA1b} signatureCount={item.signatureCount} resourceId={item.resourceId} convert={true}/>
       <Group>
      
         {item.name}
         </Group>
   </Grid.Col>
          <Grid.Col span={3}>
             <Group  spacing={5} mt={2} position="right">
               <DocReadButtons resourceId={item.resourceId} readinorigress={readinorigress} setreadinorigress={setreadinorigress} drnId={drnId} isReadOut={item.isReadOut} />
         </Group>
   </Grid.Col>
 </Grid>
 <hr />
 </div>
   );
 });


  return (
    <>

    {!showscrollbar &&
      <>
        {rows}
      </>
      }
      {showscrollbar &&
      <>
      <ScrollArea h={420} type="hover" offsetScrollbars>
        {rows}
      </ScrollArea>
      </>
      }
    </>
  );
}

export default DocRead ;